import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import { STAR_RATING_SECTION } from './index';
import * as styles from './average-star-rating-and-total.style';

interface AverageRatingTextProps {
  value: number;
  section: STAR_RATING_SECTION;
  testIdPrefix?: string;
}

const AverageRatingText: React.FC<AverageRatingTextProps> = ({
  value,
  section,
  testIdPrefix = '',
}) => (
  <StackItem>
    <span
      css={styles.avgRating(section)}
      data-testid={`${testIdPrefix}average-rating-stars_text`}
    >
      {value.toFixed(1)}
    </span>
  </StackItem>
);

export default AverageRatingText;
